import { GsFormField, GsFormSchema } from '../../../components';
import { PictureDisplayMode } from '../../../models';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { pictureDisplayModeSchemaFor } from './../basics/picture-display-mode.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { HORIZONTAL_ALIGNMENT_SCHEMA } from './alignment.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the shopping cart overview component form.
 * Defines the fields to display for the form.
 */
export const SHOPPING_CART_OVERVIEW_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...HORIZONTAL_ALIGNMENT_SCHEMA,
    ...SPACING_SCHEMA,
    {
      formControlName: 'newForDays',
      label: 'components.shoppingCart.schema.newForDays',
      type: 'number',
      default: 10,
      min: 1
    },
    {
      formControlName: 'showImage',
      label: 'components.shoppingCart.schema.showImage',
      type: 'checkbox',
      default: true,
      groupingName: 'components.shoppingCart.schema.items'
    },
    {
      ...pictureDisplayModeSchemaFor('pictureDisplayMode', undefined, undefined, 'components.shoppingCart.schema.items'),
      // Cut keeps the previous hard-coded object-cover as default
      default: PictureDisplayMode.Cut,
      if: {
        args: [{ formControlName: 'showImage', value: true }]
      }
    } as GsFormField<never>,
    {
      formControlName: 'showTitle',
      label: 'components.shoppingCart.schema.showTitle',
      type: 'checkbox',
      default: true,
      groupingName: 'components.shoppingCart.schema.items'
    },
    {
      formControlName: 'showSubtitle',
      label: 'components.shoppingCart.schema.showSubtitle',
      type: 'checkbox',
      default: true,
      groupingName: 'components.shoppingCart.schema.items'
    },
    {
      formControlName: 'showPricePerItem',
      label: 'components.shoppingCart.schema.showPricePerItem',
      type: 'checkbox',
      default: true,
      groupingName: 'components.shoppingCart.schema.items'
    },
    {
      formControlName: 'continueShoppingText',
      label: 'components.shoppingCart.schema.continueShoppingText',
      type: 'text',
      default: 'Continue shopping',
      groupingName: 'components.shoppingCart.schema.continueShopping'
    },
    {
      formControlName: 'showAdditionalLink',
      label: 'components.shoppingCart.schema.showAdditionalLink',
      type: 'checkbox',
      default: false,
      groupingName: 'components.shoppingCart.schema.continueShopping'
    },
    {
      if: {
        args: [{ formControlName: 'showAdditionalLink', value: true }]
      },
      formControlName: 'continueToHomeText',
      label: 'components.shoppingCart.schema.continueHomeText',
      type: 'text',
      default: '',
      groupingName: 'components.shoppingCart.schema.continueShopping'
    },
    // Button settings (nested under 'buttons' property)
    {
      formControlName: 'buttons',
      label: 'components.shoppingCart.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
